import * as constants from "./../store/constants";
import * as logger from "./../logger";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core";
import React from "react";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
export function useRunAfterUpdate() {
  const afterPaintRef = React.useRef(null);
  React.useLayoutEffect(() => {
    if (afterPaintRef.current) {
      afterPaintRef.current();
      afterPaintRef.current = null;
    }
  });
  const runAfterUpdate = (fn) => (afterPaintRef.current = fn);
  return runAfterUpdate;
}
const useStyles = makeStyles((theme) => ({
  divV1: {
    display: "flex",
    height: "100%",
  },
  divToastError: {
    width: "3%",
    backgroundColor: "red",
  },
  divV2: {
    display: "flex",
    alignItems: "center",
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: 15,
  },
  closeIconV1: {
    color: "red",
  },
  divTitle: {
    fontSize: 20,
    fontWeight: 300,
    letterSpacing: "1px",
  },
  divMessage: {
    fontSize: 16,
    fontWeight: "normal",
    color: "#505050",
  },
  mlV1: {
    marginLeft: 10,
  },
  divToastSuccess: {
    width: "3%",
    backgroundColor: "#00875a",
  },
  done: {
    color: "#00875a",
    fontSize: 40,
  },
}));

function ErrorToastMessage({ title, message, closeToast }) {
  const classes = useStyles();

  return (
    <div className={classes.divV1}>
      <div className={classes.divToastError}>&nbsp;</div>
      <div className={classes.divV2}>
        <div>
          <CloseIcon classname={classes.closeIconV1} />
        </div>
        <div className={classes.mlV1}>
          <div className={classes.divTitle}>{title ? title : "Failed"}</div>
          <div className={classes.divMessage}>{message}</div>
        </div>
      </div>
    </div>
  );
}

export function SuccessToastMessage({ message, closeToast }) {
  const classes = useStyles();

  return (
    <div className={classes.divV1}>
      <div className={classes.divToastSuccess}>&nbsp;</div>
      <div className={classes.divV2}>
        <div>
          <CheckCircleOutlinedIcon className={classes.done} />
        </div>
        <div className={classes.mlV1}>
          <div className={classes.divTitle}>Success</div>
          <div className={classes.divMessage}>{message}</div>
        </div>
      </div>
    </div>
  );
}

export const sendSucces = (messageValue, position) => {
  toast.success(<SuccessToastMessage message={messageValue} />, {
    className: "toastContainer",
    closeOnClick: true,
    closeButton: true,
    pauseOnHover: false,
  });
};

export const sendError = (messageValue, title) => {
  toast.error(<ErrorToastMessage title={title} message={messageValue} />, {
    className: "toastContainer",
    closeOnClick: true,
    closeButton: true,
    // transition: Zoom,
    pauseOnHover: false,
  });
};

export const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1 ");

export const numberFormatWithOutSpace = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1");

export const amountFormatOnly = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1 ");

export const numberFormatPaisa = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1 ");
export const numberFormatPaisaV2 = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1");

export const numberFormatPaisaV1 = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
    .format(isNaN(value) ? 0 : value)
    .replace(/^(\D+)/, "$1 ");

export const numberFormatComma = (value1) => {
  logger.log("Utils", typeof value1);

  var value = value1 ? value1.toString() : "";
  logger.log("Utils", value);
  logger.log("Utils", value.length);
  return value && value.length > 0
    ? new Intl.NumberFormat("en-IN").format(value)
    : "";
};

export const removeNumberCommas = (numberString) => {
  return numberString && numberString.length > 0
    ? numberString.replace(/,/g, "")
    : "";
};
export const UPITest = (upi) => {
  return upi ? /^[\w.-]+@[\w.-]+$/.test(upi) : false;
};

// Function to get day in words
export const getDayInWords = (dateTimeInMillisString) => {
  if (!dateTimeInMillisString) return "";
  var responseDate = new Date(Number(dateTimeInMillisString + "000"));
  var dayName = responseDate.toString().split(" ")[0];
  return dayName;
};

/**
 * Function to render date in format DD MMM YYYY
 * @param {*} dateTimeInMillisString
 */
export const getDateInStringDDMMMYYYY = (dateTimeInMillisString) => {
  if (!dateTimeInMillisString) return "";
  logger.log("Utils", dateTimeInMillisString);
  var responseDate = new Date(Number(dateTimeInMillisString + "000"));
  logger.log("Utils", "responseDate", responseDate);
  return (
    responseDate.getDate() +
    " " +
    constants.MONTHS[responseDate.getMonth()] +
    " " +
    responseDate.getFullYear()
  );
};

export const getDateInStringDocumentDDMMMYYYY = (dateTimeInMillisString) => {
  if (!dateTimeInMillisString) return "";
  var responseDate = new Date(Number(dateTimeInMillisString + "000"));
  return (
    ("0" + responseDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[responseDate.getMonth()] +
    " " +
    responseDate.getFullYear()
  );
};

export const getDateInStringMMMYYYY = (dateTimeInMillisString) => {
  if (!dateTimeInMillisString) return "";
  var responseDate = new Date(Number(dateTimeInMillisString + "000"));
  return (
    constants.MONTHS[responseDate.getMonth()] + " " + responseDate.getFullYear()
  );
};

/**
 * Function to get milliseconds value from date format DD MMM YYYY
 * @param {*} dateString
 */
export const getTimeInMillisDDMMMYYYY = (dateString) => {
  return dateString && dateString.length > 0
    ? new Date(dateString.split(" ").reverse().join("-")).getTime() / 1000
    : null;
};

/**
 * Function to render date in format DD MMM YYYY
 * @param {*} datePickerDate
 */
export const getDatePickerDateInStringDDMMMYYYY = (datePickerDate) => {
  if (!datePickerDate) return "";
  return (
    ("0" + datePickerDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[datePickerDate.getMonth()] +
    " " +
    datePickerDate.getFullYear()
  );
};

export const getMilliDatePickerDateInStringDDMMMYYYY = (
  datePickerDateValue
) => {
  if (!datePickerDateValue) return "";
  var datePickerDate = new Date(Number(datePickerDateValue + "000"));
  return (
    ("0" + datePickerDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[datePickerDate.getMonth()] +
    " " +
    datePickerDate.getFullYear()
  );
};

// *********************************** Function to return time in "Monday, 27 Jun 2020, 5:30 PM" format ***********************************
export const getMilliDateInDayDateTime = (datePickerDateValue) => {
  if (!datePickerDateValue) return "";
  var datePickerDate = new Date(Number(datePickerDateValue + "000"));
  var time = getTimeInHHMM(datePickerDateValue);
  var dateFormattedValue =
    constants.WEEK_DAYS[datePickerDate.getDay()] +
    ", " +
    ("0" + datePickerDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[datePickerDate.getMonth()] +
    " " +
    datePickerDate.getFullYear() +
    ", " +
    time;
  return dateFormattedValue;
};

/**
 * Function to render date in format DD MMM
 * @param {*} datePickerDate
 */
export const getDateFilterStringDDMMM = (datePickerDate) => {
  if (!datePickerDate) return "";
  return (
    ("0" + datePickerDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[datePickerDate.getMonth()]
  );
};

export const getDateStringDDMMM = (datePickerDate) => {
  if (!datePickerDate) return "";
  var responseDate = new Date(Number(datePickerDate + "000"));
  return (
    ("0" + responseDate.getDate()).slice(-2) +
    " " +
    constants.MONTHS[responseDate.getMonth()]
  );
};

export const getTimeInHHMM = (dateValue) => {
  if (!dateValue) return "";
  var responseDate = new Date(Number(dateValue + "000"));
  var hours = responseDate.getHours();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  var minutes = responseDate.getMinutes();
  var strTime =
    ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + " " + ampm;

  return strTime;
};

/**
 * Function to return the time in Python required truncated value
 */
export const getRequestTimeInMillis = (date) => {
  return Math.round(date.getTime() / 1000);
};

export const prepareDate = (d) => {
  var [d, m, y] = d.split("-"); //Split the string
  return [y, m - 1, d]; //Return as an array with y,m,d sequence
};
/**
 * Utility method to get filter values for Trip Start Date filter
 */
export const getTripStartDateFilterValues = () => {
  var dateFilterValues = {};

  var currentDate = new Date();
  // 1. Today
  var todayDate = new Date(currentDate.setHours(0, 0, 0, 0));
  var todayEndDate = new Date(currentDate.setHours(23, 59, 59, 999));
  dateFilterValues["TODAY"] = {
    value: "Today",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(todayDate)),
      endTimeEpoch: Number(getRequestTimeInMillis(todayEndDate)),
    },
    filterEntry: getDateFilterStringDDMMM(todayDate),
  };

  // 2. This week
  var thisWeekStart = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    todayDate.getDate() - todayDate.getDay()
  );
  var thisWeekEnd = new Date(
    thisWeekStart.getFullYear(),
    thisWeekStart.getMonth(),
    thisWeekStart.getDate() + 6
  );
  thisWeekEnd.setHours(23, 59, 59, 999);
  dateFilterValues["THIS_WEEK"] = {
    value: "This week",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(thisWeekStart)),
      endTimeEpoch: Number(getRequestTimeInMillis(thisWeekEnd) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(thisWeekStart) +
      " - " +
      getDateFilterStringDDMMM(thisWeekEnd),
  };

  // 3. Last week
  var lastWeekStart = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    todayDate.getDate() - todayDate.getDay() - 7
  );
  var lastWeekEnd = new Date(
    lastWeekStart.getFullYear(),
    lastWeekStart.getMonth(),
    lastWeekStart.getDate() + 6
  );
  lastWeekEnd.setHours(23, 59, 59, 999);
  dateFilterValues["LAST_WEEK"] = {
    value: "Last week",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(lastWeekStart)),
      endTimeEpoch: Number(getRequestTimeInMillis(lastWeekEnd) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(lastWeekStart) +
      " - " +
      getDateFilterStringDDMMM(lastWeekEnd),
  };

  // 4. This month
  var thisMonthStart = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    1
  );
  var thisMonthEnd = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth() + 1,
    0
  );
  thisMonthEnd.setHours(23, 59, 59, 999);
  dateFilterValues["THIS_MONTH"] = {
    value: "This month",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(thisMonthStart)),
      endTimeEpoch: Number(getRequestTimeInMillis(thisMonthEnd) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(thisMonthStart) +
      " - " +
      getDateFilterStringDDMMM(thisMonthEnd),
  };

  // 5. Last month
  var lastDayOfPreviousMonth = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    0
  );
  //lastDayOfPreviousMonth.setHours(-1);
  lastDayOfPreviousMonth.setHours(23, 59, 59, 999);
  var firstDayOfPreviousMonth = new Date(
    lastDayOfPreviousMonth.getFullYear(),
    lastDayOfPreviousMonth.getMonth(),
    1
  );
  dateFilterValues["LAST_MONTH"] = {
    value: "Last month",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(firstDayOfPreviousMonth)),
      endTimeEpoch: Number(getRequestTimeInMillis(lastDayOfPreviousMonth) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(firstDayOfPreviousMonth) +
      " - " +
      getDateFilterStringDDMMM(lastDayOfPreviousMonth),
  };

  // 6. Last 3 months
  var startMonth3 = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth() - 3,
    1
  );
  var endMonth3 = new Date(
    startMonth3.getFullYear(),
    startMonth3.getMonth() + 3,
    0
  );
  endMonth3.setHours(23, 59, 59, 999);
  dateFilterValues["LAST_3_MONTHS"] = {
    value: "Last 3 months",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(startMonth3)),
      endTimeEpoch: Number(getRequestTimeInMillis(endMonth3) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(startMonth3) +
      " - " +
      getDateFilterStringDDMMM(endMonth3),
  };

  // 7. This Year
  var yearStartDate = new Date(todayDate.getFullYear(), 0, 1);
  var yearEndDate = new Date(todayDate.getFullYear(), 11, 31);
  yearEndDate.setHours(23, 59, 59, 999);
  dateFilterValues["YEAR"] = {
    value: "This year",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(yearStartDate)),
      endTimeEpoch: Number(getRequestTimeInMillis(yearEndDate) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(yearStartDate) +
      " - " +
      getDateFilterStringDDMMM(yearEndDate),
  };

  // 8. All Months
  var allMonthsStartDate = new Date("2019-01-01");
  allMonthsStartDate.setHours(0, 0, 0, 0);
  var allMonthsEndDate = new Date(currentDate.setHours(23, 59, 59, 999));
  dateFilterValues["ALL_MONTHS"] = {
    value: "All Months",
    startDateRange: {
      startTimeEpoch: Number(getRequestTimeInMillis(allMonthsStartDate)),
      endTimeEpoch: Number(getRequestTimeInMillis(allMonthsEndDate) - 1),
    },
    filterEntry:
      getDateFilterStringDDMMM(allMonthsStartDate) +
      " - " +
      getDateFilterStringDDMMM(allMonthsEndDate),
  };

  // 9. Custom
  dateFilterValues["CUSTOM"] = {
    value: "Custom",
    startDateRange: { startTimeEpoch: "", endTimeEpoch: "" },
    filterEntry: "",
  };
  return dateFilterValues;
};

export const getTripDateFilterValues = () => {
  var dateFilterValues = {};
  var currentDate = new Date();
  var todayDate = new Date(currentDate.setHours(0, 0, 0, 0));

  // 1. This Year
  var yearStartDate = new Date(todayDate.getFullYear(), 0, 1);
  var yearEndDate = new Date(todayDate.getFullYear(), 11, 31);
  yearEndDate.setHours(23, 59, 59, 999);
  dateFilterValues["YEAR"] = {
    value: "This Year",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(yearStartDate),
      endTimeEpoch: getRequestTimeInMillis(yearEndDate) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(yearStartDate) +
      " - " +
      getDateFilterStringDDMMM(yearEndDate),
  };

  // 2. This month
  var thisMonthStart = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    1
  );
  var thisMonthEnd = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth() + 1,
    0
  );
  thisMonthEnd.setHours(23, 59, 59, 999);
  dateFilterValues["THIS_MONTH"] = {
    value: "This Month",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(thisMonthStart),
      endTimeEpoch: getRequestTimeInMillis(thisMonthEnd) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(thisMonthStart) +
      " - " +
      getDateFilterStringDDMMM(thisMonthEnd),
  };

  // 3. Last month
  var lastDayOfPreviousMonth = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    0
  );
  //lastDayOfPreviousMonth.setHours(-1);
  lastDayOfPreviousMonth.setHours(23, 59, 59, 999);
  var firstDayOfPreviousMonth = new Date(
    lastDayOfPreviousMonth.getFullYear(),
    lastDayOfPreviousMonth.getMonth(),
    1
  );
  dateFilterValues["LAST_MONTH"] = {
    value: "Last Month",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(firstDayOfPreviousMonth),
      endTimeEpoch: getRequestTimeInMillis(lastDayOfPreviousMonth) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(firstDayOfPreviousMonth) +
      " - " +
      getDateFilterStringDDMMM(lastDayOfPreviousMonth),
  };

  // 4. All Months
  var allMonthsStartDate = new Date("2019-01-01");
  allMonthsStartDate.setHours(0, 0, 0, 0);
  var allMonthsEndDate = new Date(currentDate.setHours(23, 59, 59, 999));
  dateFilterValues["ALL_MONTHS"] = {
    value: "All Months",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(allMonthsStartDate),
      endTimeEpoch: getRequestTimeInMillis(allMonthsEndDate) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(allMonthsStartDate) +
      " - " +
      getDateFilterStringDDMMM(allMonthsEndDate),
  };

  // 5. Custom
  dateFilterValues["CUSTOM"] = {
    value: "Custom",
    startDateRange: { startTimeEpoch: "", endTimeEpoch: "" },
    filterEntry: "",
  };
  return dateFilterValues;
};

export const getDateFilterValues = () => {
  var dateFilterValues = {};
  var currentDate = new Date();
  var todayDate = new Date(currentDate.setHours(0, 0, 0, 0));

  // 1. This Year
  var yearStartDate = new Date(todayDate.getFullYear(), 0, 1);
  var yearEndDate = new Date(todayDate.getFullYear(), 11, 31);
  yearEndDate.setHours(23, 59, 59, 999);
  dateFilterValues["This Year"] = {
    value: "This Year",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(yearStartDate),
      endTimeEpoch: getRequestTimeInMillis(yearEndDate) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(yearStartDate) +
      " - " +
      getDateFilterStringDDMMM(yearEndDate),
  };

  // 2. This month
  var thisMonthStart = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    1
  );
  var thisMonthEnd = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth() + 1,
    0
  );
  thisMonthEnd.setHours(23, 59, 59, 999);
  dateFilterValues["This Month"] = {
    value: "This Month",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(thisMonthStart),
      endTimeEpoch: getRequestTimeInMillis(thisMonthEnd) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(thisMonthStart) +
      " - " +
      getDateFilterStringDDMMM(thisMonthEnd),
  };

  // 3. Last month
  var lastDayOfPreviousMonth = new Date(
    todayDate.getFullYear(),
    todayDate.getMonth(),
    0
  );
  //lastDayOfPreviousMonth.setHours(-1);
  lastDayOfPreviousMonth.setHours(23, 59, 59, 999);
  var firstDayOfPreviousMonth = new Date(
    lastDayOfPreviousMonth.getFullYear(),
    lastDayOfPreviousMonth.getMonth(),
    1
  );
  dateFilterValues["Last Month"] = {
    value: "Last Month",
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(firstDayOfPreviousMonth),
      endTimeEpoch: getRequestTimeInMillis(lastDayOfPreviousMonth) - 1,
    },
    filterEntry:
      getDateFilterStringDDMMM(firstDayOfPreviousMonth) +
      " - " +
      getDateFilterStringDDMMM(lastDayOfPreviousMonth),
  };

  // 4. Custom
  dateFilterValues["Custom"] = {
    value: "Custom",
    startDateRange: { startTimeEpoch: "", endTimeEpoch: "" },
    filterEntry: "",
  };
  return dateFilterValues;
};

export const getDateFilterValueForMonthlyBalance = (value) => {
  let dateValue = "";

  if (value.includes("-")) {
    dateValue = value.split("-");
  } else {
    dateValue = value.split(" ");
  }

  let monthNumber =
    new Date(Date.parse(dateValue[0] + " 1, " + dateValue[1])).getMonth() + 1;

  let firstDayMonth = new Date(dateValue[1], monthNumber - 1, 1);
  let lastDayMonth = new Date(dateValue[1], monthNumber - 1 + 1, 0);

  let firstDayMonthValue = new Date(
    firstDayMonth.getFullYear(),
    firstDayMonth.getMonth(),
    1
  );
  let lastDayMonthValue = new Date(
    lastDayMonth.getFullYear(),
    lastDayMonth.getMonth() + 1,
    0
  );

  lastDayMonth.setHours(23, 59, 59, 999);

  return {
    startDateRange: {
      startTimeEpoch: getRequestTimeInMillis(firstDayMonth),
      endTimeEpoch: getRequestTimeInMillis(lastDayMonth) - 1,
    },
  };
};

/**
 * To iterate the list and provide the display name based on value
 */
export const getDisplayName = (list, value) => {
  if (!list || !value || list.length <= 0 || !Array.isArray(list)) return "";

  for (var i = 0; i < list.length; i++) {
    if (list[i].value == value) {
      return list[i].display;
    }
  }
  return "";
};
export const randomColorChoose = (initial) => {
  let colorArray = [
    "#0078d4",
    "#4f6bed",
    "#373277",
    "#881798",
    "#a4262c",
    "#d13438",
    "#ca5010",
  ];
  let numOfColors = colorArray.length;
  var sum = 0;
  if (initial) {
    for (let i = 0; i < initial.length; i++) {
      sum += initial.charCodeAt(i);
    }
  }
  let reminder = sum % numOfColors;
  return reminder ? colorArray[reminder] : colorArray[1];
};

// Rendering elements based on screen size . To determine mobile or desktop screen.
export const checkScreen = () => {
  var screen = {
    mobile: false,
    desktop: false,
  };
  if (window.matchMedia("(max-width: 670px)").matches) {
    screen.mobile = true;
    return screen;
  } else if (window.matchMedia("(min-width: 700px)").matches) {
    screen.desktop = true;
    return screen;
  }
};
export const findArrayObject = (key, value, array, path) => {
  if (array && Array.isArray(array)) {
    return array.find(function (a) {
      if (path) {
        for (var i = 0; i < path.length; i++) {
          if (a && typeof a == "object") {
            a = a[path[i]];
          }
        }
      }
      if (a && typeof a == "object" && a[key] == value) return a;
    });
  }
};

export const findArrayObjectIndex = (key, value, array, path, dataType) => {
  if (!isEmpty(array)) {
    for (var arrayIndex in array) {
      var a = array[arrayIndex];
      if (path) {
        for (var i = 0; i < path.length; i++) {
          if (a && typeof a == "object") {
            a = a[path[i]];
          }
        }
      }
      if (dataType == "date") {
        if (
          a &&
          typeof a == "object" &&
          new Date(a[key]).getTime() == new Date(value).getTime()
        )
          return arrayIndex;
      } else {
        if (a && typeof a == "object" && a[key] == value) return arrayIndex;
      }
    }
  }
};

export const mobileAndTabletCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const checkNumberOnly = (string) => {
  return /^\d+(\.\d{1,3})?$/.test(string);
  //return /^\d+$/.test(string);
};
export function replaceCommas(x) {
  if (x) {
    let value = x.toString();
    return value.replace(/,/g, "").trim();
  }
}
export function sortByDisplay(a, b) {
  if (a.display < b.display) {
    return -1;
  }
  if (a.display > b.display) {
    return 1;
  }
  return 0;
}

export function numberWithCommas(x) {
  if (x && checkNumberOnly(replaceCommas(x))) {
    //return x.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return new Intl.NumberFormat("en-IN", {}).format(Number(replaceCommas(x)));
  } else {
    if (x && /^[0-9,.]*$/.test(x)) {
      return x && typeof x === "string" ? x.trim() : x;
    }
    return null;
  }
}
export const amountFormatInput = (value) => {
  if (checkNumberOnly(replaceCommas(value))) {
    return new Intl.NumberFormat("en-IN", {}).format(
      Number(replaceCommas(value))
    );
  } else {
    if (value && /^[0-9,.]*$/.test(value)) {
      return value && typeof x === "string" ? value.trim() : value;
    }
    return "";
  }
};
export function filterOut(text, cursor) {
  const beforeCursor = text.slice(0, cursor);
  const afterCursor = text.slice(cursor, text.length);
  const filterdBeforeCursor = amountFormatInput(beforeCursor);
  const filterAfterCursor = amountFormatInput(afterCursor);
  const newText = amountFormatInput(beforeCursor + afterCursor);
  const newCursor = filterdBeforeCursor.length;
  return [newText, newCursor];
}
export function filterWithOutFormatting(text, cursor) {
  const beforeCursor = text.slice(0, cursor);
  const afterCursor = text.slice(cursor, text.length);
  const newText = beforeCursor + afterCursor;
  const newCursor = beforeCursor.length;

  return [newText, newCursor];
}
export function filterWithOutFormattingVehicle(text, cursor, deleteHappened) {
  const beforeCursor = text.slice(0, cursor);
  const afterCursor = text.slice(cursor, text.length);
  var alphabetRegex = /^[A-Za-z]+$/;
  var numRegex = /^\d+$/;

  let beforeSplitted = beforeCursor.split("");
  let afterSplitted = afterCursor.split("");

  let beforeCursorFormatted = "";
  let afterCursorFormatted = "";
  if (beforeSplitted.length > 0 && afterSplitted.length > 0) {
    for (let index = 0; index < beforeSplitted.length; index++) {
      const c1 = beforeSplitted[index];
      const c2 = beforeSplitted[index + 1];
      beforeCursorFormatted += c1;
      if (c1 && c2) {
        if (
          (c1.match(alphabetRegex) && c2.match(numRegex)) ||
          (c1.match(numRegex) && c2.match(alphabetRegex))
        ) {
          beforeCursorFormatted += " ";
        }
      }
    }
    for (let index = 0; index < afterSplitted.length; index++) {
      const c1 = afterSplitted[index];
      const c2 = afterSplitted[index + 1];
      afterCursorFormatted += c1;
      if (c1 && c2) {
        if (
          (c1.match(alphabetRegex) && c2.match(numRegex)) ||
          (c1.match(numRegex) && c2.match(alphabetRegex))
        ) {
          afterCursorFormatted += " ";
        }
      }
    }
    if (beforeSplitted[beforeSplitted.length - 1] && afterSplitted[0]) {
      let c1 = beforeSplitted[beforeSplitted.length - 1];
      let c2 = afterSplitted[0];
      if (
        (c1.match(alphabetRegex) && c2.match(numRegex)) ||
        (c1.match(numRegex) && c2.match(alphabetRegex))
      ) {
        beforeCursorFormatted += " ";
      }
    }
  } else if (beforeSplitted.length > 0 && afterSplitted.length == 0) {
    for (let index = 0; index < beforeSplitted.length; index++) {
      const c1 = beforeSplitted[index];
      const c2 = beforeSplitted[index + 1];
      beforeCursorFormatted += c1;
      if (c1 && c2) {
        if (
          (c1.match(alphabetRegex) && c2.match(numRegex)) ||
          (c1.match(numRegex) && c2.match(alphabetRegex))
        ) {
          beforeCursorFormatted += " ";
        }
      }
    }
    /*if (c1.match(alphabetRegex) && c2.match(numRegex) || c1.match(numRegex) && c2.match(alphabetRegex)) {
      newCursor +=1
    }*/
  } else if (beforeSplitted.length == 0 && afterSplitted.length > 0) {
    for (let index = 0; index < afterSplitted.length; index++) {
      const c1 = afterSplitted[index];
      const c2 = afterSplitted[index + 1];
      afterCursorFormatted += c1;
      if (c1 && c2) {
        if (
          (c1.match(alphabetRegex) && c2.match(numRegex)) ||
          (c1.match(numRegex) && c2.match(alphabetRegex))
        ) {
          afterCursorFormatted += " ";
        }
      }
    }
    /*if (c1.match(alphabetRegex) && c2.match(numRegex) || c1.match(numRegex) && c2.match(alphabetRegex)) {
      newCursor +=1
    }*/
  }
  const newText = beforeCursorFormatted + afterCursorFormatted;
  let newCursor = beforeCursorFormatted.length;

  return [newText, newCursor];
}

export function numberWithCommasInput(evt, stateFunc) {
  if (!evt || !stateFunc) {
    return null;
  }
  if (evt && stateFunc) {
    const input = evt.target;
    const text = input.value;
    const cursor = input.selectionStart;
    const [newValue, newCursor] = filterOut(text, cursor);
    window.requestAnimationFrame(() => {
      input.selectionStart = newCursor;
      input.selectionEnd = newCursor;
    });
    stateFunc(newValue);
  }
}
// export const numberWithCommas = (value) => new Intl.NumberFormat("en-IN", {}).format(isNaN(Number(replaceCommas(value))) ? null : value).replace(/^(\D+)/, '$1 ')
export function pos_to_neg(num) {
  if (num) {
    return -Math.abs(Number(num));
  } else {
    return 0;
  }
}

export function isEmpty(obj) {
  if (typeof obj === "number" || typeof obj === "boolean") return false;
  if (obj == null) return true;
  if (obj instanceof Date) {
    return isNaN(obj);
  }
  if (obj instanceof Set) {
    return obj.size === 0;
  }
  //if (typeof obj[index] === "undefined" && obj[index] === null) return true;
  if (obj.length === 0) return true;
  if (obj.length > 0) return false;
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }
  return true;
}

// Vehicle number validation.
export function vehicleNumberValidation(vehicleNumber, regex) {
  if (vehicleNumber) {
    // let vehicleNumberRegex = "^([A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{1,4})$|^([A-Z]{3}[0-9]{1,4})$|^[A-Z]{2}[0-9]{3,6}$"
    let vehicleNumberRegex = "^([A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4})$";
    let checkNumber = new RegExp(regex ? regex : vehicleNumberRegex);
    return checkNumber.test(vehicleNumber);
  }
}

// Vehicle number split.
// export const getVehicleNumberValuesDWeb = (vehicleNumber) => {

//   if (vehicleNumber) {
//     return vehicleNumber.match(/[\d]+|[A-Z|a-z]+/g);
//   }

// };

export const getVehicleNumberValuesDWeb = (vehicleNumber) => {
  if (vehicleNumber) {
    let data = vehicleNumber.match(/[\d]+|[A-Z|a-z]+/g);

    if (data && data.length == 2) {
      return [vehicleNumber, "", ""];
    }
    return data;
  }
};

export const calculateDiscount = (listPrice, salePrice) => {
  listPrice = parseFloat(listPrice);
  salePrice = parseFloat(salePrice);
  return 100 - (salePrice * 100) / listPrice; // Discount percentage
};
export const capitalizeTheWord = (sentence) => {
  return sentence
    ? sentence.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
    : "";
};
export const validNumberCheck = (val) => {
  return checkNumberOnly(replaceCommas(val)) && Number(replaceCommas(val)) > 0
    ? true
    : false;
};

//Formatting phone numbers.
export function formatPhoneNumber(phoneNumber) {
  if (phoneNumber) {
    if (phoneNumber.length > 5) {
      return phoneNumber.slice(0, 5) + "-" + phoneNumber.slice(5);
    } else {
      return phoneNumber;
    }
  }
}

//Checking decimal number validation.
export function validateDecimalNumber(amount) {
  return amount.match(/[1-9]\d*(\.\d+)?/);
}
export function GetDays(endDate) {
  var dropdt = new Date(endDate);
  var pickdt = new Date();
  var dateDifference = Math.floor(
    (Date.UTC(dropdt.getFullYear(), dropdt.getMonth(), dropdt.getDate()) -
      Date.UTC(pickdt.getFullYear(), pickdt.getMonth(), pickdt.getDate())) /
      (1000 * 60 * 60 * 24)
  );
  return dateDifference;
}

//monthValue should be in 'June 2021' format.
export function getEpochForSpecificMonth(monthValue) {
  let monthArray = monthValue.split(" ");

  var monthNumber = new Date(
    Date.parse(monthArray[0] + " 1, " + monthArray[1])
  ).getMonth();
  var monthStart = new Date(monthArray[1], monthNumber, 1);
  var monthEnd = new Date(monthArray[1], monthNumber + 1, 1);

  const monthEpoch = {
    startTimeEpoch: getRequestTimeInMillis(monthStart),
    endTimeEpoch: getRequestTimeInMillis(monthEnd) - 1,
  };

  return monthEpoch;
}
export const isEmptyObject = (value) => {
  return value && Object.keys(value).length === 0 ? true : false;
};
export const getVehicleInputValue = (vehicleNumber) => {
  if (!vehicleNumber) {
    return null;
  }
  var alphabetRegex = /^[A-Za-z]+$/;
  var numRegex = /^\d+$/;
  let splitted = vehicleNumber.split("");
  let newNumber = "";
  if (splitted && splitted.length >= 1) {
    for (let index = 0; index < splitted.length; index++) {
      const c1 = splitted[index];
      const c2 = splitted[index + 1];
      newNumber += c1;
      if (c1 && c2) {
        if (
          (c1.match(alphabetRegex) && c2.match(numRegex)) ||
          (c1.match(numRegex) && c2.match(alphabetRegex))
        ) {
          newNumber += " ";
        }
      }
    }
  }
  return newNumber;
  /*var newVehicleNumber = vehicleNumber;
  var alphabetRegex = /^[A-Za-z]+$/;
  var numRegex = /^\d+$/;
  var numLength = vehicleNumber.length;
  if (numLength > 1) {
      if ((vehicleNumber[numLength - 1].match(alphabetRegex) && vehicleNumber[numLength - 2].match(numRegex))
          || (vehicleNumber[numLength - 1].match(numRegex) && vehicleNumber[numLength - 2].match(alphabetRegex))){
          newVehicleNumber = vehicleNumber.substring(0, numLength - 1) + ' ' + vehicleNumber[numLength - 1]
      }else if(vehicleNumber.slice(-4).match(numRegex)){
        newVehicleNumber = vehicleNumber.substring(0, numLength - 4) + ' ' + vehicleNumber.slice(-4)
      }
  }
  return newVehicleNumber;*/
};
export const vehicleNumberDisplay = (value) => {
  let nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  if (value) {
    let final = "";
    for (let i = 0; i < value.length; i++) {
      if (value.charAt(i) && i != 0) {
        let pre = value[i - 1];
        let next = value[i + 1];
        let active = value[i];
        if (!nums.includes(Number(pre)) && nums.includes(Number(active))) {
          final += ` ${active}`;
        } else if (
          nums.includes(Number(pre)) &&
          !nums.includes(Number(active))
        ) {
          final += ` ${active}`;
        } else {
          final += active;
        }
      } else {
        final += value.charAt(i);
      }
    }
    return final;
  }
  return "";
};
export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}
export function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

// function to convert Snake_Case to camelCase
export const snakeCaseToCamelCase = (str) => {
  return str
    .toLowerCase()
    .replace(/[_][a-z]/g, (text) => text.slice(-1).toUpperCase());
};
export const sumCalculation = (items, prop) => {
  return items.reduce(function (a, b) {
    return a + b[prop];
  }, 0);
};
export function hasDecimal(num) {
  return !!(num % 1);
}
export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}
export const spaceOnly = (v) => v.trim().length === 0;
export const mobileNumberInputFormat = (number) => {
  let n = number.replace(/-/g, "");
  let n1 = n.slice(0, 5);
  let n2 = n.slice(5);
  if (n2) return [n1, n2].join("-");
  else return n1;
};
export const listMonthsBetweenDate = (start, end) => {
  if (start) {
    var dateStart = moment(start);
    var dateEnd = end?moment(end):new Date();
    var timeValues = [];

    while (
      dateEnd > dateStart ||
      moment(dateStart).format("M") === moment(dateEnd).format("M")
    ) {
      timeValues.push({
        year:moment(dateStart).format("YYYY"),
        value:moment(dateStart).format("MMM-YYYY"),
        display:moment(dateStart).format("MMMM YYYY")
      });
      dateStart.add(1, "month");
    }
    return timeValues
  }
  return null;
};
export const filterByYear = (items) =>{
  if(items){
    let filterd={};
    items.forEach(item => {
      if(item&&item.value&&item.year){
        if(!filterd[item.year]){
          filterd[item.year] = [];
          filterd[item.year].push(item);
        }else{
          filterd[item.year].push(item);
        }
      }
    });
    return filterd;
  }
}
